import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BellIcon from '../../../assets/bell.svg'
import Notifications from './Notifications';
import ChangePassword from './ChangePassword';
import EditProfile from './EditProfile';
import Gmail from '../../../assets/dashboard/gmail.svg';
// import UserIcon from '../../../assets/dashboard/user-image.png';
// import TelIcon from '../../../assets/dashboard/tell-1.svg';
import ChangePasswordIcon from '../../../assets/dashboard/lock.svg';
import LogOut from '../../../assets/dashboard/logout.svg';
import EditProfileIcon from '../../../assets/dashboard/edit-profile.svg';
import UpArrowIcon from '../../../assets/dashboard/up-arrow.svg';
import { getFromLocalStorage, removeFromLocalStorage } from '../../../utils/storageUtil';
import { GetNotifications } from '../../../utils/api';
import { GetNotificationsCount } from '../../../utils/api';
import { message } from 'antd';


const Header = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [openChangePass, setOpenChangePass] = useState(false);
  const [openEditProfile, setOpenEditProfile] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const dropdownRef = useRef(null);
  const [notificationCount, setNotificationCount] = useState(0);
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownVisible(false);
    }
  };

  const handleChangePassClick = () => {
    setDropdownVisible(false);
    setOpenChangePass(true);
  }

  const handleEditProfile = () => {
    setDropdownVisible(false);
    setOpenEditProfile(true);
  }

  const handleLogoutClick = () => {
    removeFromLocalStorage('admin');
    setDropdownVisible(false);
    navigate('/auth/login', { replace: true });
  }

  const getNotifications = async () => {
    setLoading(true);
    try {
      let params = 'notification_type=toAdmin';
      const response = await GetNotifications(params);
      if (response?.isSuccess) {
        setNotifications(response?.items);
      } else {
        message.error(response?.error);
      }
    } catch (error) {
    }
    finally {
      setLoading(false);
    }
  }
  const getNotificationsCount = async () => {
    // setLoading(true);
    const id = getFromLocalStorage('admin')?.id;
    try {
      let params = `notification_type=toAdmin&userId=${id}`;
      const response = await GetNotificationsCount(params);
      if (response) {
        setNotificationCount(response?.count);
      } else {
        message.error(response?.error);
      }
    } catch (error) {
    }
    finally {
      // setLoading(false);
    }
  }


  const handleBellClick = () => {
    setOpen(true);
    getNotifications();
  }

  useEffect(() => {
    setInterval(() => getNotificationsCount(), 10000);
    // getNotificationsCount();
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className='bg-white w-full h-12 flex items-center justify-end gap-x-8 px-3'>
        {/* Drawer */}
        <div className='relative'>
          {notificationCount > 0 && <span className='absolute bg-[#907F83] w-4 h-4 rounded-full flex items-center justify-center text-white text-[10px] -top-2 -right-2'>{notificationCount}</span>}
          <img className='cursor-pointer' src={BellIcon} alt='bell-icon' width={16} onClick={handleBellClick} />
        </div>
        <div className='flex gap-x-2 items-center relative transition' ref={dropdownRef}>
          <div className='flex gap-x-2 items-center cursor-pointer' onClick={() => setDropdownVisible(!dropdownVisible)}>
            <h2 className='text-[12px] user-name-head'>{getFromLocalStorage('admin').name}</h2>
            <div className=' user-image flex gap-1'>
              <img className='2xl:w-9 w-8 h-8 object-cover rounded-full border border-primary-900 p-[2px]' src={getFromLocalStorage('admin').image} alt="admin-avatar" />
              <img src={UpArrowIcon} alt="dropdown-icon" className={`${dropdownVisible ? 'rotate-0' : 'rotate-180'}`} />
            </div>
          </div>
          {
            dropdownVisible && <div className='w-[250px] text-xs absolute right-0 top-11 bg-primary-300 box-shadow rounded-lg z-[9999]'>
              <div className='flex px-4 pt-4 items-center gap-x-1 '>
                <div className=' w-3/12 relative cursor-pointer' onClick={handleEditProfile}>
                  <img className='w-12 h-12 object-cover rounded-full border border-primary-900 p-[2px]' src={getFromLocalStorage('admin').image} alt="admin-avatar" />
                  <span className='absolute right-1 top-8'><img src={EditProfileIcon} alt="edit-profile" /></span>
                </div>
                <div className=' w-9/12 flex flex-col gap-y-1 leading-none'>
                  <span className='font-medium text-xs'>{getFromLocalStorage('admin').name}</span>
                  <div className='flex items-center gap-2'>
                    <span><img className='w-3 h-3' src={Gmail} alt="gmail" /> </span>
                    <p className='text-lightGray text-xs'>{getFromLocalStorage('admin').email}</p>
                  </div>
                </div>
              </div>
              <div className='flex  pt-4 flex-col gap-y-3'>
                <div className='flex px-4 items-center gap-2 cursor-pointer' onClick={handleChangePassClick}>
                  <span><img className='w-4 h-4' src={ChangePasswordIcon} alt="changepassword-img" /></span>
                  <p className='text-lightGray'>Change Password</p>
                </div>
                <div className='bg-red-500 px-4 rounded-b-lg flex items-center gap-2 py-3 cursor-pointer' onClick={handleLogoutClick}>
                  <span><img className='w-4 h-4' src={LogOut} alt="logout-img" /></span>
                  <p className=' font-medium text-red-900'>Logout</p>
                </div>
              </div>
            </div>
          }

        </div>
      </div>
      <Notifications open={open} setOpen={setOpen} loading={loading} setLoading={setLoading} notifications={notifications} />
      <ChangePassword openChangePass={openChangePass} setOpenChangePass={setOpenChangePass} />
      <EditProfile openEditProfile={openEditProfile} setOpenEditProfile={setOpenEditProfile} />
    </>
  )
}

export default Header;